// Shared table styling so every data table in the app matches.
export const TABLE_ROW =
  'border-b border-line hover:bg-surface-sunken/60 transition-colors';

export const TABLE_HEADER_ROW =
  'uppercase text-2xs font-semibold tracking-wide text-content-secondary border-b border-line';

export const HEADER_CELL =
  'px-2 py-2 md:px-4 md:py-3 whitespace-nowrap overflow-hidden truncate';

export const BODY_CELL = 'px-2 py-2 md:px-4 md:py-3';
